import { render } from "./Create.vue?vue&type=template&id=2c64fe66&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "../../assets/css/client.css?vue&type=style&index=0&id=2c64fe66&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c64fe66"]])

export default __exports__